import React, { useEffect } from "react";
import {
  Container as DragContainer,
  Draggable,
} from "components/react-smooth-dnd";
import KanbanColumn from "./KanbanColumn";
import LoadingOverlay from "components/LoadingOverlay";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import NewGroup from "../components/NewGroup";
import { useDispatch, useSelector } from "react-redux";
import { createGroupTask } from "actions/groupTask/createGroupTask";
import { selectCreateGroupTaskStatus } from "./selectors";
import "./style.scss";

const Container = ({ className = "", isDraggingOver, innerRef, ...props }) => (
  <div
    ref={innerRef}
    className={`view_KanbanBoard___container ${className}`}
    {...props}
  />
);

const NewGroupTaskDiv = ({ className = "", ...props }) => (
  <div className={`view_KanbanBoard___new-grouptask ${className}`} {...props} />
);

function KanbanBoard(props) {
  const {
    tasks,
    loading,
    handleColumnDrop,
    handleItemDrop,
    handleOpenModal,
    placeholderProps,
    projectId,
    workType,
    canManageGroupTask,
    canUpdateProject,
  } = props;

  const { t } = useTranslation();
  const [addGroup, setAddGroup] = React.useState(false);
  const dispatch = useDispatch();
  const createGroupTaskStatus = useSelector(selectCreateGroupTaskStatus());

  function onSubmit(name) {
    dispatch(
      createGroupTask({
        projectId,
        name,
        description: "",
      })
    );
  }

  useEffect(() => {
    if (createGroupTaskStatus === "success") {
      setTimeout(() => {
        scrollToAddGroup();
      }, 1000);
    }
  }, [createGroupTaskStatus]);

  const stageName =
    workType === 2 ? t("IDS_WP_PHASE") : t("LABEL_CHAT_TASK_NHOM_VIEC");

  const scrollToAddGroup = () => {
    const element = document.getElementById("kanban-board-scrollbar");
    const addGroupEle = document.getElementById("add-kanban-group");
    if (element && addGroupEle) {
      element.scrollLeft =
        addGroupEle.offsetLeft + addGroupEle.offsetWidth + 310;
    }
  };
  console.log(tasks, "tasks kanban");
  return (
    <LoadingOverlay
      active={loading}
      spinner
      fadeSpeed={0}
      style={{
        height: "100%",
        zIndex: "999",
        overflow: "hidden",
      }}
      className={"loading-overlay__kanban-board"}
    >
      <Container id="kanban-board-scrollbar" style={{ height: "100%" }}>
        <DragContainer
          onDrop={(dropResult) =>
            handleColumnDrop(
              dropResult.removedIndex,
              dropResult.addedIndex,
              dropResult.payload
            )
          }
          getChildPayload={(index) => get(tasks, `[${index}]`, {})}
          orientation="horizontal"
          dragClass="view_KanbanColumn___container-drag"
          dropClass="view_KanbanColumn___container-drop"
          dragHandleSelector='[data-custom-drag-handle="column-handle"]'
          dropPlaceholder={{
            animationDuration: 150,
            showOnTop: true,
            className: "view_KanbanColumn___container-preview",
          }}
        >
          {tasks.map((groupTask, index) => {
            return (
              <Draggable key={get(groupTask, "id")}>
                <KanbanColumn
                  groupTask={groupTask}
                  key={index}
                  index={index}
                  handleOpenModal={handleOpenModal}
                  placeholderProps={placeholderProps}
                  projectId={projectId}
                  handleItemDrop={handleItemDrop}
                  stageName={stageName}
                />
              </Draggable>
            );
          })}
        </DragContainer>
        {addGroup && (
          <div id="add-kanban-group" style={{ height: "100%" }}>
            <NewGroup setAddGroup={setAddGroup} onSubmit={onSubmit} />
          </div>
        )}
        {canUpdateProject && !addGroup && (
          <div style={{ height: "100%" }}>
            <NewGroupTaskDiv onClick={() => setAddGroup(true)}>
              {`+ ${t("LABEL_ADD_NEW_GROUP")}`}
            </NewGroupTaskDiv>
          </div>
        )}
      </Container>
    </LoadingOverlay>
  );
}

export default KanbanBoard;
